/**
 * XPAC API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Interval = 'hourly' | 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly';

export const Interval = {
    Hourly: 'hourly' as Interval,
    Daily: 'daily' as Interval,
    Weekly: 'weekly' as Interval,
    Monthly: 'monthly' as Interval,
    Quarterly: 'quarterly' as Interval,
    Yearly: 'yearly' as Interval
};

